import get from 'lodash/get'

export const getMessage = state => get(state, 'assets.message')
export const getLogo = state => get(state, 'assets.logo')
